import { render } from "./ProdutoCheckoutView.vue?vue&type=template&id=696eb3d5&scoped=true"
import script from "./ProdutoCheckoutView.vue?vue&type=script&lang=js"
export * from "./ProdutoCheckoutView.vue?vue&type=script&lang=js"

import "./ProdutoCheckoutView.vue?vue&type=style&index=0&id=696eb3d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696eb3d5"]])

export default __exports__